export default "Garderhøjfortet opened their 3 mathematical escape rooms in July 2021.";